import React from 'react';

import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { IHeroSuperText } from './types';

const SuperText = styled.h1`
  font-family: ${Styles.fontFamily.base};
  color: ${p => p.theme.token('text-active')};
  font-size: calc(32.25px - 0.1rem);
  font-weight: normal;
  letter-spacing: -1px;
  line-height: 90%;
  margin: 0 0 ${primitive.$spacing2} 0;
  text-align: center;
  width: 100%;
  text-shadow: none;
  opacity: 0.9;

  // For Larger desktops, attempt to "contain" the super text
  @media screen and (min-width: 1300px) {
    width: 60%;
  }

  ${Styles.desktop`
    opacity: 1;
    margin-bottom: ${primitive.$spacing8};
    font-size: 5rem;
    text-align: left;
  `}
`;

// does not utilize the sanity-sourced heroTextColor value
export const HeroSuperText: React.FC<IHeroSuperText> = ({ children }) => {
  return <SuperText>{children}</SuperText>;
};
